var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rc-msjReserva"},[_c('v-icon',[_vm._v("error")]),_vm._v(" "+_vm._s(_vm.textoData)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }